import React from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Rocket, Sparkles, Code } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/50" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <Badge className="bg-purple-600/20 text-purple-400 border-purple-600/30 mb-4" data-testid="about-badge">
            About Us
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-testid="about-title">
            Innovating at the Speed of Thought
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" data-testid="about-description">
            We are a digital venture studio specializing in rapid development of innovative web applications. 
            From social platforms and influencer networks to enterprise tools and marketplaces, we turn ambitious ideas into market-ready products.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <Card className="bg-slate-800/50 border-slate-700" data-testid="about-card-speed">
            <CardHeader>
              <Rocket className="w-12 h-12 text-blue-400 mb-4" />
              <CardTitle className="text-white">Rapid Development</CardTitle>
              <CardDescription className="text-slate-300">
                We leverage our proprietary high-velocity cloud stack to build full-stack applications in record time, 
                without compromising on quality or functionality.
              </CardDescription>
            </CardHeader>
          </Card>

          <Card className="bg-slate-800/50 border-slate-700" data-testid="about-card-innovation">
            <CardHeader>
              <Sparkles className="w-12 h-12 text-purple-400 mb-4" />
              <CardTitle className="text-white">Innovation First</CardTitle>
              <CardDescription className="text-slate-300">
                Every project we undertake pushes the boundaries of what's possible, 
                creating unique solutions tailored to modern challenges.
              </CardDescription>
            </CardHeader>
          </Card>

          <Card className="bg-slate-800/50 border-slate-700" data-testid="about-card-partnership">
            <CardHeader>
              <Code className="w-12 h-12 text-green-400 mb-4" />
              <CardTitle className="text-white">True Partnership</CardTitle>
              <CardDescription className="text-slate-300">
                We work closely with our clients from concept to launch, 
                ensuring their vision is realized exactly as imagined.
              </CardDescription>
            </CardHeader>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;